// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"3a6c217d","787":"5c6e7b50","983":"844bc5ae"}[chunkId] + ".chunk.js";
};